import React from "react";

const LinkIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M2 2.5C2 2.22386 2.22386 2 2.5 2H6C6.27614 2 6.5 1.77614 6.5 1.5C6.5 1.22386 6.27614 1 6 1H2.5C1.67157 1 1 1.67157 1 2.5V9.5C1 10.3284 1.67157 11 2.5 11H9.5C10.3284 11 11 10.3284 11 9.5V6C11 5.72386 10.7761 5.5 10.5 5.5C10.2239 5.5 10 5.72386 10 6V9.5C10 9.77614 9.77614 10 9.5 10H2.5C2.22386 10 2 9.77614 2 9.5V2.5Z"
        fill="#646F87"
      />
      <path
        d="M7.5 1.5C7.5 1.22386 7.72386 1 8 1H10C10.5523 1 11 1.44772 11 2V4C11 4.27614 10.7761 4.5 10.5 4.5C10.2239 4.5 10 4.27614 10 4V2.70711L6.35355 6.35355C6.15829 6.54882 5.84171 6.54882 5.64645 6.35355C5.45118 6.15829 5.45118 5.84171 5.64645 5.64645L9.29289 2H8C7.72386 2 7.5 1.77614 7.5 1.5Z"
        fill="#646F87"
      />
    </svg>
  );
};

export default LinkIcon;
